import { Component, OnDestroy } from '@angular/core';
@Component({
  selector: 'app-request-list-ord',
  templateUrl: './request-list-ord.component.html',
  standalone: false,
})
export class RequestListOrdComponent implements OnDestroy {
  ngOnDestroy() {
    sessionStorage.removeItem('savedFilters');
  }
}
